export default __webpack_public_path__ + "static/media/gift-cards.inline.dfd258b8.svg";